var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AggregateColumn_1;
/* eslint-disable import/no-duplicates */
/* eslint-disable no-redeclare */
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './enumToolVariable'; // force import for JsonSchema
import './stringToolVariable'; // force import for JsonSchema
import './columnToolVariable'; // force import for JsonSchema
// declare here it can be used in the schema
var OperationEnum;
(function (OperationEnum) {
    OperationEnum["MAX"] = "MAX";
    OperationEnum["MIN"] = "MIN";
    OperationEnum["COUNT"] = "COUNT";
    OperationEnum["SUM"] = "SUM";
    OperationEnum["AVERAGE"] = "AVG";
    OperationEnum["OR"] = "OR";
    OperationEnum["AND"] = "AND";
    OperationEnum["MEDIAN"] = "MEDIAN";
    OperationEnum["DIFF"] = "DIFF";
    OperationEnum["PERCENTAGE"] = "PCT";
    OperationEnum["SHIFT"] = "SHIFT";
    OperationEnum["STDEV"] = "STDEV";
})(OperationEnum || (OperationEnum = {}));
const schema = {
    $id: 'urn:wisepipe-base-pipe:AggregateColumn',
    type: 'object',
    properties: {
        column: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable'
                },
                { type: 'string' }
            ]
        },
        operation: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:EnumToolVariable'
                },
                { type: 'string', enum: Object.values(OperationEnum) }
            ]
        },
        alias: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:StringToolVariable'
                },
                { type: 'string' }
            ]
        }
    },
    required: ['operation', 'alias'],
    if: { not: { properties: { operation: { const: OperationEnum.COUNT } } } },
    then: { required: ['column'] }
};
let AggregateColumn = AggregateColumn_1 = class AggregateColumn {
    constructor(operation, alias, column) {
        this.operation = operation;
        this.alias = alias;
        this.column = column;
        JSON.validate(this, AggregateColumn_1);
    }
    applyParameters(parameters) {
        const baseVals = this.getBaseValues(parameters);
        return new AggregateColumn_1(baseVals.operation, baseVals.alias, baseVals.column);
    }
    getBaseValues(parameters) {
        return {
            operation: parameters.getEnumVal(this.operation),
            alias: parameters.getStrVal(this.alias),
            column: parameters.getStrOrUndefVal(this.column)
        };
    }
};
AggregateColumn = AggregateColumn_1 = __decorate([
    JsonSchema(schema)
], AggregateColumn);
export { AggregateColumn };
(function (AggregateColumn) {
    AggregateColumn.Operation = OperationEnum;
})(AggregateColumn || (AggregateColumn = {}));
//# sourceMappingURL=aggregateColumn.js.map